<template>
  <div>
    <h4 v-if="seleccionarImporte">Podés seleccionar un importe de la lista o <a @click.prevent="seleccionarImporte = false">escribir un importe.</a></h4>
    <h4 v-else>Escribir importe manual o <a @click.prevent="seleccionarImporte = true">elegir de la lista.</a></h4>

    <v-chip-group
        v-model="importeSeleccionado"
        active-class="deep-purple accent-4 white--text"
        column
        v-if="seleccionarImporte"
      >
        <v-chip v-for="(importe, index) in importesCercanos" :key="`chip_importe_${index}`">${{ importe }}</v-chip>
      </v-chip-group>

    <v-text-field
      outlined
      color="primary"
      v-model="importeEscrito"
      prepend-inner-icon="mdi-cash"
      v-mask="'######.##'"
      label="Ingrese el importe"
      :error-messages="mensajeErrorImporte"
      v-if="!seleccionarImporte">
    </v-text-field>
  </div>
</template>
<style scoped>
a {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}
a:hover {
  color: #1565c0;
}
</style>
<script>
export default {
  name: 'ElegirImporteContado',
  mounted () {
    this.calcularImportesCercanos()
  },
  props: {
    total: {
      type: [Function, Number, String],
      required: true
    }
  },
  data () {
    return {
      importe: null,
      importesCercanos: [],
      importeSeleccionado: null,
      importeEscrito: null,
      seleccionarImporte: true
    }
  },
  computed: {
    mensajeErrorImporte () {
      if (this.seleccionarImporte) return []
      if (this.importeEscrito === null || this.importeEscrito === '') return []
      if (!this.esImporteValido(this.importeEscrito)) {
        return [`El importe debe ser mayor o igual a $${Number(this.importe).toFixed(2)}`]
      }
      return []
    }
  },
  watch: {
    importeSeleccionado (val) {
      if (val !== null && this.importesCercanos[val]) {
        this.$emit('importe-elegido', this.importesCercanos[val])
        this.$emit('importe-invalido', false)
      }
    },
    importeEscrito (val) {
      this.$emit('importe-elegido', val)
      this.$emit('importe-invalido', !this.esImporteValido(val))
    },
    seleccionarImporte (val) {
      if (val) {
        if (this.importeSeleccionado !== null && this.importesCercanos[this.importeSeleccionado]) {
          this.$emit('importe-elegido', this.importesCercanos[this.importeSeleccionado])
          this.$emit('importe-invalido', false)
        }
      } else {
        this.$emit('importe-elegido', this.importeEscrito)
        this.$emit('importe-invalido', !this.esImporteValido(this.importeEscrito))
      }
    },
    total: {
      handler () {
        this.calcularImportesCercanos()
        if (!this.seleccionarImporte) {
          this.$emit('importe-invalido', !this.esImporteValido(this.importeEscrito))
        }
      },
      deep: true
    }
  },
  methods: {
    esImporteValido (val) {
      if (val === null || val === undefined || val === '') return false
      const numero = parseFloat(String(val).replace(',', '.'))
      if (isNaN(numero)) return false
      return numero >= Number(this.importe)
    },
    calcularImportesCercanos () {
      const raw = typeof this.total === 'function' ? this.total() : this.total
      this.importe = Number(raw)
      if (!this.importe || this.importe <= 0) {
        this.importesCercanos = []
        return
      }

      const minimo = Math.ceil(this.importe / 100) * 100
      const billetes = [100, 500, 1000, 2000, 10000, 20000]
      // 5000 no es billete, pero da montos redondos típicos (15000, 25000, etc.)
      const pasosRedondeo = [100, 500, 1000, 2000, 5000, 10000, 20000]
      const sugerencias = new Set([minimo])

      pasosRedondeo.forEach((paso) => {
        sugerencias.add(Math.ceil(this.importe / paso) * paso)
      })
      billetes.forEach((billete) => {
        if (billete >= minimo) sugerencias.add(billete)
      })

      let ordenados = [...sugerencias]
        .filter((n) => n >= minimo)
        .sort((a, b) => a - b)

      const maxOpciones = 5
      if (ordenados.length > maxOpciones) {
        ordenados = ordenados.slice(0, maxOpciones)
        const billeteGrande = [...billetes].reverse().find((b) => b >= minimo)
        if (billeteGrande && !ordenados.includes(billeteGrande)) {
          ordenados[ordenados.length - 1] = billeteGrande
          ordenados = [...new Set(ordenados)].sort((a, b) => a - b)
        }
      }

      this.importesCercanos = ordenados
      this.importeSeleccionado = 0
    }
  }
}
</script>
